export const emailProps = {
  question: 'What’s your email address?',
  questionInfo: 'This will be your username and the main way we keep in touch.',
  messageBanner:
    'We’re a paperless insurance provider. Once it’s verified, this email address is how we’ll send your policy documents. It’ll also be your username for the app and web dashboard.',
  dataCy: 'email-input-field',
  name: 'email',
  placeholder: 'Email address',
  autoComplete: 'email',
}

export const mobileProps = {
  question: 'What’s your mobile number?',
  questionInfo: 'We’ll use this number to update you with any important information about your insurance.',
  dataCy: 'mobile-number-input-field',
  name: 'mobile-number',
  placeholder: 'Mobile number',
  infoModalText:
    'Please use the number of the mobile you’ll download our app with. This has to be correct in case we need to contact you.',
  autoComplete: 'mobile tel',
}
